import { EstadosEfectivo } from "@/constants/enums/status/entity-status-ids";
import { AppColors } from "@/styles/colors";
import { Flex, Link, Text } from "@chakra-ui/react";
import { Info } from "lucide-react";
import { FieldValues, UseFormSetValue } from "react-hook-form";

interface Props {
  submitFilters: (event: FieldValues) => Promise<void>;
  setValue: UseFormSetValue<FieldValues>;
  label?: string;
  statusToSet?: (string | number)[]
}

export const PendingMessagesAlert = ({
  submitFilters,
  setValue,
  label = "Tiene mensajes pendientes",
  statusToSet = [String(EstadosEfectivo.RequiereInformacion)]
}: Props) => {
  const handleSubmitFilters = () => {
    setValue("estados", statusToSet);
    submitFilters({
      estados: statusToSet,
    });
  };
  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      bgColor={AppColors.LIGHT_BLUE}
      paddingY="8.5px"
      paddingX="30px"
      minWidth="600px"
      borderRadius="5px"
      maxHeight="41px"
    >
      <Flex alignItems="center" gap="12px">
        <Info color={AppColors.BLUE_TEXT} />
        <Text>{label}</Text>
      </Flex>

      <Link onClick={handleSubmitFilters}>
        <Text fontWeight={700}>Revisar</Text>
      </Link>
    </Flex>
  );
};
